import { render, staticRenderFns } from "./GuestInfoSpecialBooking.vue?vue&type=template&id=1352ddc6&scoped=true"
import script from "./GuestInfoSpecialBooking.vue?vue&type=script&lang=js"
export * from "./GuestInfoSpecialBooking.vue?vue&type=script&lang=js"
import style0 from "./GuestInfoSpecialBooking.vue?vue&type=style&index=0&id=1352ddc6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1352ddc6",
  null
  
)

export default component.exports